import React from 'react';
import styles from './styles';

const BaseRouteLanding = props => {

  if (localStorage.lastInstance)
    props.history.push({pathname:'/' + localStorage.lastInstance + '/'});

  return(
    <div style={styles.container}>
      <div style={styles.content}>

      </div>
    </div>
  )
}

export default BaseRouteLanding;
